<div *ngIf="inventoryModalIsOpen" class="inventory-modal">
  <div class="h-100">
    <a href="#" class="icon close" (click)="handleClose(); $event.preventDefault()">
      <img src="/assets/images/icon/close.svg"/>
  </a>
    <div class="row h-100">
      <div class="col-12 col-lg-6">
        <div class="p-5 h-100 modal-section">
          <p class="title">Select Tools to Inventory</p>
          <app-tool-inventory-id-modal-search #inventoryIdSearch></app-tool-inventory-id-modal-search>
          <app-tool-inventory-modal-search #inventorySearch></app-tool-inventory-modal-search>
          <div class="selected">
            <div class="d-flex justify-content-between align-items-center">
              <p>
                <strong>Selected Tools ({{ tableData.data.length }})</strong>
                <span>Check tools to include in a transfer.</span>
              </p>
              <button (click)="handleClear()">Clear</button>
            </div>
            <app-tool-settings-table
              class="scroll"
              [headers]="tableData"
              [rows]="tableData.data"></app-tool-settings-table>
          </div>
        </div>
      </div>
      <div class="col-12 col-lg-6 border-left border-md-top border-md-left-0">
        <div class="p-5 h-100 modal-section">
          <p class="title small">Choose Where You Want to Inventory Tools</p>
          <p class="body">
            You can inventory selected tools to another job, employee, location, or shop. This action is will update all
            tools chosen.
          </p>
          <app-tool-inventory-modal-assignment
            (transfer)="triggerTransfer()"
          ></app-tool-inventory-modal-assignment>
        </div>
      </div>
    </div>
  </div>
</div>
